import { ProvinceRepository, Province, ProvinceRepositoryError } from '@/Domain/Localization/Province'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'
import { ProvinceFactory } from '@/Domain/Localization/Province/ProvinceFactory'
import { AxiosProvinceData } from '@/Infrastructure/Localization/Province/Persistence/Axios'

export class AxiosProvinceRepository implements ProvinceRepository {
  private _apiClient: ApiClient
  private _provinceFactory: ProvinceFactory<AxiosProvinceData>

  constructor (apiClient: ApiClient, provinceFactory: ProvinceFactory<AxiosProvinceData>) {
    this._apiClient = apiClient
    this._provinceFactory = provinceFactory
  }

  async findAll (): Promise<Province[]> {
    try {
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/localization/provinces',
        {}
      )
      const provinces = response.data.data.provinces.map((current: AxiosProvinceData) => {
        return this._provinceFactory.makeProvince(current)
      })
      return provinces
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new ProvinceRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }
}
